<template>
    <div class="container-padded w-4/5 space-y-8 shadow-md sm:p-12">
        <h2>Features</h2>
        <ul class="list-disc">
            <li>Storefront - Your public webpage with search indexing</li>
            <li>Search - Customers can find you by name, service type, or even other organizations you belong to</li>
            <li>Referral Network - Get leads from your Pro connections</li>
            <li>Pings - Send private messages with Pros and Customers</li>
        </ul>
    </div>
</template>

<script>
export default {
    props:["user"],
    name: "ProFeatures",
    methods: {

    }
}
</script>

<style scoped>

</style>
